const assetsEn = {
    asset: require('../../lang/en/assets/Asset').default,
    assetIssue: require('../../lang/en/assets/AssetIssue').default,
    toolsPartsTransfer: require('../../lang/en/assets/ToolsPartsTransfer').default,
    toolsPartsReturn: require('../../lang/en/assets/ToolsPartsReturn').default,
    inventory: require('../../lang/en/assets/Inventory').default,
    amc: require('../../lang/en/assets/Amc').default,
}

export default assetsEn;

